export const siteURL = window.location.href;

export const updateLinkTrackingFields = ({ pageName, formName, formStatus, journeyName, journeyStepName, journeyStatus }) => {
    if (pageName) digitalData.page.pageInfo.pageName = pageName;
    if (formName) digitalData.page.form.name = formName;
    if (formStatus) digitalData.page.form.status = formStatus;
    if (journeyName) digitalData.page.journey.name = journeyName;
    if (journeyStepName) digitalData.page.journey.stepName = journeyStepName;
    if (journeyStatus) digitalData.page.journey.status = journeyStatus;
}
